export const SubSectorType = {
    SUBSECTOR: 1,
    FUNCTIONS: 2
}